import { Model } from "@vuex-orm/core";
import Customer from "./Customer";
import User from "./User";

export default class Note extends Model {
  static entity = "notes";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      // accountId: this.number(0),
      id: this.attr(),
      isDirty: this.boolean(false),
      customerId: this.number(0),
      note: this.attr(),
      userId: this.number(0),
      customer: this.belongsTo(Customer, "customerId"),
      user: this.belongsTo(User, "userId")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
